import { ContestWithId } from "../interfaces/IContests";
import { createContext, ReactNode, useContext } from "react";

interface ContestContextType {
  contest: ContestWithId | null;
}

const CotnestContext = createContext<ContestContextType | undefined>(undefined);

export default function ContestProvider({
  contest,
  children,
}: {
  contest: ContestWithId;
  children: ReactNode;
}) {
  return (
    <CotnestContext.Provider
      value={{
        contest,
      }}
    >
      {children}
    </CotnestContext.Provider>
  );
}

export const useContestContext = (): ContestContextType => {
  const context = useContext(CotnestContext);
  if (context === undefined) {
    throw new Error(
      "Błąd w ContestContext: useContestContext must be used within an ContestProvider"
    );
  }
  return context;
};
